import { useFormik } from "formik";
import React, { useState } from "react";
import * as Yup from "yup";
import { ReRegistrationRemindMeLater } from "../../services/ReRegistrationService";
import Swal from "sweetalert2";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import ReRegAvatar from "./ReRegAvatar";
import { setReRegistrationsReload } from "../../store/actions";
import styled from "styled-components";
import { useBrandVideo } from "../../hooks/useBrandVideo";
import ButtonGroup from "../ui/ButtonGroup";
import Button from "../ui/Button";
import VideoPopup from "../video-popup/VideoPopup";
const SummaryHelperText = styled.p`
  margin: 4px 0 0 0;
  font-size: 10px;
  line-height: 1.1;
  color: ${(props) => props.$color || "var(--gray1)"};
`;

function PMCReRegUpcommingForm({ data }) {
    const dispatch = useDispatch();
    const [isRemindMeLoading, setIsRemindMeLoading] = useState(false);
    const reload = useSelector((state) => state.registrations.reload);

    const { isOpen, openVideo, closeVideo, iframeUrl, fallbackVideoUrl, hasVideo } = useBrandVideo();

    const handleRemindMeLater = () => {
        setIsRemindMeLoading(true);
        let params = {
            rereg_course_id: data?.id,
            intake_year: data?.intake_year,
            intake_number: data?.intake_number,
            academy_type: data?.academy_type,
            remind: 1,
            submit_reason: 0,
        };
        if (data?.reregistration_id) {
            params = { ...params, rereg_id: data?.reregistration_id };
        }
        ReRegistrationRemindMeLater(params)
            .then(() => {
                setIsRemindMeLoading(false);
                Swal.fire({
                    icon: "success",
                    title: "Success",
                    text: "Remind me later set successfully",
                }).then((result) => {
                    if (result.isConfirmed) {
                        dispatch(setReRegistrationsReload(!reload));
                        window.location.href = "/home";
                    }
                });
            })
            .catch((error) => {
                console.error("error PMC Rereg remind", error);
                setIsRemindMeLoading(false);
            });
    };

    return (
        <>
            <div className="launch__form">
                <div className="card card-profile-info-card mb-4">
                    <div className="card-body re-reg-card">
                        <div className="row align-items-center justify-content-center">
                            <div className="col-md-4">
                                <figure>
                                    <ReRegAvatar />
                                </figure>
                            </div>
                            <div className="col-md-6">
                                <div className="d-flex flex-column" noValidate>
                                    <h3 className="mt-0"></h3>
                                    <h4>
                                        {`${data?.intake_year} Intake ${data?.intake_number}`}{" "}
                                        <span style={{ color: "var(--topbar-color", fontWeight: "bold" }}>
                                            Re-registration
                                        </span>{" "}
                                        &{" "}
                                        <span style={{ color: "var(--topbar-color", fontWeight: "bold" }}>
                                            Articulation
                                        </span>{" "}
                                        Opening Soon!
                                    </h4>
                                    <p>
                                        Re-registration & articulation will open once exam results are released{" "}
                                        {(data?.hard_launch_date && Number(data?.hard_launch_date)) > 0
                                            ? `on ${moment(Number(data?.hard_launch_date ?? 0) * 1000).format("DD MMM YYYY")} at 12:00 `
                                            : ""}
                                        <SummaryHelperText $color="#c1232c">
                                            If you are scheduled for supplementary exams, your re-registration will only
                                            open once your supplementary results are available.
                                        </SummaryHelperText>
                                    </p>
                                    {/* display span errors */}

                                    <ButtonGroup className="show-shadow mt-3">
                                        <Button
                                            type="button"
                                            variant="dark"
                                            onClick={handleRemindMeLater}
                                            disabled={isRemindMeLoading}
                                        >
                                            {isRemindMeLoading ? (
                                                <i className="fas fa-cog fa-spin"></i>
                                            ) : (
                                                <i className="fal fa-bell-slash"></i>
                                            )}
                                            Remind Me Later
                                        </Button>
                                        {Number(data?.PMCId) > 0 && hasVideo && (
                                            <Button
                                                type="button"
                                                variant="white"
                                                onClick={openVideo}
                                            >
                                                <i className="fal fa-play" />
                                                Watch Video
                                            </Button>
                                        )}
                                    </ButtonGroup>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {isOpen && (
                <VideoPopup
                    open={isOpen}
                    onOpenChange={closeVideo}
                    iframe={iframeUrl}
                    videoUrl={fallbackVideoUrl}
                />
            )}
        </>
    );
}

export default PMCReRegUpcommingForm;